import {createGeneralPageEventsAndComponents} from "../components/page-general";
import {createHomepageElements} from "../components/homepage-elements";
import { createPromotionBar } from "../components/promotion-bar";
import { expressQuerySelector } from "../common/html";
window.addEventListener('load', () => {
	// Promotion bar
	const promotionBar = expressQuerySelector<HTMLElement>(document, '.technical-promotion-bar', false);
	if (promotionBar)
		createPromotionBar(promotionBar);

	createGeneralPageEventsAndComponents();
	createHomepageElements();
});
